import React from 'react';
import Row from "../../../SDFormTemplate/Row";
import Section from '../../../SDFormTemplate/Section';
import Accordion from 'components/Common/Accordion/Accordion';

function Create({ setInvalidConditions, setFormData }) {
  
  const title = 'Getting Started';

  const createSection = ([
    <Section
      key='create_section_name'
      title='Name'
      required
      checkInvalid
      setInvalidConditions={setInvalidConditions}
      setFormData={setFormData}
      characterLimit={28}
    />,
    <Section
      key='create_section_account_type'
      title='Account Type'
      type='dropdown'
      placeholder='Select an account type...'
      inlineWrapperStyles={{ marginBottom: '12px' }}
      mapFromObject={{
        'Enterprise': 'Enterprise',
        'Installer View': 'Installer View',
      }}
      required
      checkInvalid
      setInvalidConditions={setInvalidConditions}
      setFormData={setFormData}
    />,
    <Section
      key='create_section_domain'
      title='Domain'
      setFormData={setFormData}
    />,
    <Section
      key='create_section_logo'
      title='Logo' type="image"
      checkInvalid
      valueType='file'
      setInvalidConditions={setInvalidConditions}
      setFormData={setFormData}
    />,
    <Section
      key='create_section_engineers_mode'
      title='Engineers Mode'
      valueType='bool'
      type="checkbox"
      setFormData={setFormData}
    />,
  ])

  return (
    <div key="create">
      <Row
        key='row_1'
        sections={[
          (index) => (
            <Accordion
              key='accordion_1'
              title={title}
              accordionHeaderSection={true}
              accordionHeaderContents={{
                size: 'md',
                message: 'Get started with the basic account information.',
              }}
              showNumberInHeader={false}
              headerNumber={index + 1}
              content={[
                createSection,
              ]}
              openOnLoad={true}
            />
          )
        ]}
      />
    </div>
  )
}

export default Create;
